import {
  type AIProviderId,
  creatableAIProviders,
  getAIProvider,
} from "../../../shared/aiProviders";
import { queries } from "../../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";
import {
  SearchableDropdown,
  RowButton,
  SectionLabel,
} from "../SearchableDropdown";
import { Icon } from "../Icon";
import { ProviderLogo } from "../ProviderLogo";
import { DropdownOpener } from "../Settings/shared";
import { Text } from "../Text";

export function ProviderSelect({
  value,
  disabled,
  onChange,
}: {
  value: AIProviderId;
  disabled: boolean;
  onChange: (provider: AIProviderId) => void;
}) {
  const [flags] = useQuery(queries.featureFlags());
  return (
    <SearchableDropdown
      style={{ width: "100%" }}
      align="left"
      disabled={disabled}
      searchPlaceholder="Search providers…"
      opener={
        <DropdownOpener as="span">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              minWidth: 0,
            }}
          >
            <ProviderLogo provider={value} size={16} />
            <Text variant="text-regular" ellipsis>
              {getAIProvider(value).label}
            </Text>
          </span>
          <span style={{ opacity: 0.3 }}>
            <Icon name="chevron-down" size={12} />
          </span>
        </DropdownOpener>
      }
    >
      {(query, close) => {
        const q = query.toLowerCase().trim();
        const matches = creatableAIProviders.filter(
          (candidate) =>
            (!candidate.featureFlag ||
              flags.some((flag) => flag.name === candidate.featureFlag)) &&
            (!q ||
              candidate.label.toLowerCase().includes(q) ||
              candidate.description.toLowerCase().includes(q))
        );
        if (matches.length === 0) {
          return (
            <SectionLabel>
              <Text variant="text-small" color="var(--text-secondary)">
                No providers found.
              </Text>
            </SectionLabel>
          );
        }
        return matches.map((candidate) => (
          <RowButton
            key={candidate.id}
            onClick={() => {
              onChange(candidate.id);
              close();
            }}
          >
            <ProviderLogo provider={candidate.id} size={16} />
            <div style={{ flex: 1, minWidth: 0, textAlign: "left" }}>
              <Text variant="text-regular" color="var(--text-primary)" ellipsis>
                {candidate.label}
              </Text>
            </div>
            {candidate.id === value && (
              <span className="row-idle">
                <Icon name="check" size={12} color="var(--text-secondary)" />
              </span>
            )}
          </RowButton>
        ));
      }}
    </SearchableDropdown>
  );
}
